import LegalPageLayout from '../components/layout/LegalPageLayout';

const SECTIONS = [
  {
    heading: '1. What Are Cookies',
    body: 'Cookies are small text files stored on your device when you visit a website or use an app. They help the site remember information about your visit, such as your preferences and login state.',
  },
  {
    heading: '2. How We Use Cookies',
    body: 'We use cookies to keep you signed in, remember your theme preference, understand how you use PCredit so we can improve it, and protect the platform against fraud and abuse.',
  },
  {
    heading: '3. Types of Cookies We Use',
    body: 'Essential cookies — required for core functionality like authentication and security.\nPreference cookies — remember settings such as light/dark mode.\nAnalytics cookies — help us understand usage patterns so we can improve the product.',
  },
  {
    heading: '4. Managing Cookies',
    body: 'Most browsers let you control or delete cookies through their settings. Disabling essential cookies may prevent parts of PCredit from working correctly, such as staying signed in.',
  },
  {
    heading: '5. Changes to This Policy',
    body: 'We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.',
  },
  {
    heading: '6. Contact Us',
    body: 'If you have questions about our use of cookies, contact us at support@mypcredit.com or through our Contact Us page.',
  },
];

export default function CookiePolicy() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Cookie Policy"
      updated="September 2026"
      sections={SECTIONS}
    />
  );
}
